<style>
.wh-fade-toast-enter {
  opacity: 0;
}
.wh-fade-toast-enter-active,
.wh-fade-toast-leave-active {
  transition: opacity 0.4s;
}
.wh-fade-toast-leave-active {
  opacity: 0;
}
* {
  margin: 0;
  padding: 0;
}
/* wh-toast */
.wh-toast {
  position: fixed;
  z-index: 9999;
  line-height: .32rem;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.wh-toast-message {
  font-size: 16px;
  padding: 12px 24px;
  text-align: center;
  color: #fff;
  border-radius: .12rem;
  background: #323232;
  opacity: 0.9;
}
</style>
<template>
  <transition name="wh-fade-toast">
    <div v-if="is_show" class="wh-toast" @touchmove.self.prevent>
      <div class="wh-toast-message">
        {{content}}
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  data() {
    return {
      is_show: false, //是否显示toast
      duration: 1500, //停留的时间
      content: "" //显示的内容
    };
  }
};
</script>